<template>
  <v-card class="my-5 transparent" height="100%" width="100%" outlined>
    <CarouselBox class="mt-8" :items="carouselItems" :hideDelimiter="true" @action="setCarouselIndexHandler" />
    <template v-for="subject in cardSubjectList">
      <v-card class="ma-8 transparent" :key="subject" outlined>
        <v-card-text>
          <v-row justify="center" justify-sm="space-between" align="center">
            <v-card-title class="text-h5 font-weight-black _light_grey--text">{{ $t(subject) }}</v-card-title>
            <v-btn class="mb-5 _blue _light_grey--text" @click="routerFilterList(subject)">{{ $t('seeMore') }}</v-btn>
          </v-row>
          <v-row justify="start">
            <template v-for="data in cardDataList(subject).slice(0, cardCount)">
              <CardV class="mb-5" :data="data" :key="data.name" @click="cardHandler(data.name)" />
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <!-- <CarouselMultiPic :items="carouselLogo" :showCount="1" :hideDelimiter="true" /> -->
    <v-overlay :value="hasCarousel" @click.native="hasCarousel = false">
      <CarouselBox
        :items="carouselItems"
        :showArrows="true"
        :isCycle="false"
        :hideDelimiter="true"
        :model="carouselIndex"
        :hasVideo="true"
        @action="carouselDetailHandler"
      />
    </v-overlay>
    <v-overlay :value="hasVideo" @click.native="hasVideo = false">
      <iframe class="iframeSize" title="Video" height="auto" :src="videoUrl" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </v-overlay>
    <!-- <v-dialog v-model="showBulletin" persistent width="800">
      <v-card style="position: relative; width: 100%">
        <v-card-text class="text-center pt-8">
          <div class="ql-editor" v-html="bulletinContent" />
        </v-card-text>
        <v-card-actions>
          <v-checkbox v-model="isNoShowNext" :label="$t('hintNextTimeNotShow')"></v-checkbox>
          <v-spacer></v-spacer>
          <v-btn color="_blue" class="white--text" @click="closeBulletin()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CarouselBox from '@/components/CarouselBox.vue';
// import CarouselMultiPic from '@/components/CarouselMultiPic.vue';
import Db from '@/api/awsDb';
import File from '@/api/file';
import CardV from '../components/CardV.vue';

export default {
  name: 'Main',
  components: {
    CarouselBox,
    // CarouselMultiPic,
    CardV,
  },
  data: () => ({
    logoList: null,
    marqueeList: [],
    hasCarousel: false,
    hasVideo: false,
    videoUrl: '',
    carouselIndex: 0,
    showBulletin: false,
    isNoShowNext: false,
    bulletin: '',
    recommendList: {
      item: [],
      rating: [],
      install: [],
      operation: [],
      lvq: [],
    },
  }),
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapState('dbTable', ['filterList', 'filterSubject']),
    ...mapGetters('dbTable', ['productList', 'publisherList']),
    ...mapGetters('locale', ['locale']),
    userIndustry() {
      if (!this.isSignIn) return 'All';
      return this.userAttribute.industrys;
    },
    topProductList() {
      const list = [...this.productList];
      return list.sort((a, b) => b.rating - a.rating);
    },
    newProductList() {
      const list = [...this.productList];
      return list.sort((a, b) => b.updateTime - a.updateTime);
    },
    recommendProductList() {
      let list = [];
      if (Object.keys(this.recommendList.rating).length > 0 && this.recommendList.rating.R1 !== '0') {
        list = this.recommendList.rating;
      } else if (Object.keys(this.recommendList.install).length > 0 && this.recommendList.install.R1 !== '0') {
        list = this.recommendList.install;
      } else if (Object.keys(this.recommendList.operation).length > 0 && this.recommendList.operation.R1 !== '0') {
        list = this.recommendList.operation;
      } else {
        list = this.recommendList.lvq;
      }
      if (list.length === 0) return [];
      const ary = [];
      for (let i = 1; i < Object.keys(list).length; i += 1) {
        if (list[`R${i}`] !== '0') {
          const temp = this.productList.find((x) => x.name === list[`R${i}`]);
          if (temp !== undefined) ary.push(temp);
        }
      }
      return ary;
    },
    cardSubjectList() {
      switch (this.$route.name) {
        default:
        case 'main':
          return ['new&update', 'recommend', 'popular', 'free'];
        case 'popularRankings':
          return ['popular&free', 'popular&paid'];
        case 'newProducts':
          return ['new&free', 'new&paid'];
      }
    },
    cardCount() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 4;
        case 'sm':
          return 3;
        case 'md':
          return 4;
        default:
        case 'lg':
          return 7;
        case 'xl':
          return 10;
      }
    },
    carouselLogo() {
      if (this.logoList == null) return [];
      return this.logoList.logo.map((x) => process.env.VUE_APP_S3_URL + x);
    },
    carouselList() {
      return this.marqueeList.filter((x) => x.locale === this.locale);
    },
    carouselItems() {
      if (!this.carouselList.length) return [];
      if (this.userIndustry === 'All') return this.carouselList.map((item) => ({ src: item.thumbnail }));
      return this.carouselList.filter((x) => x.industrys === this.userIndustry).map((item) => ({ src: item.thumbnail }));
    },
    bulletinContent() {
      return this.bulletin[this.locale];
    },
  },
  created() {
    this.loadLogo();
    Db.scan('marquee').then((res) => {
      this.marqueeList = res.sort((a, b) => b.updatedAt - a.updatedAt);
    });
    Db.scan('info').then((res) => {
      this.bulletin = res.find((x) => x.id === 'notice-1').datas;
    });
    const expiredDate = window.localStorage.getItem('bulletinExpiredDate');
    if (expiredDate !== new Date().toLocaleDateString()) {
      this.showBulletin = true;
    }
    this.$root.$emit('clearFilter');
    Db.read('recommendLvq', 'name', 'LVQ').then((res) => {
      this.recommendList.lvq = res === undefined ? [] : res;
    });
  },
  mounted() {
    this.$store
      .dispatch('authenticate/currentUser')
      .then((user) => {
        Db.scan('comment', { email: user.attributes.email }, ['id']).then((res) => {
          if (res.length >= 3) {
            Db.read('recommendRating', 'email', user.attributes.email).then((result) => {
              this.recommendList.rating = result === undefined ? [] : result;
            });
          }
        });
        Db.scan('install', { email: user.attributes.email }, ['id']).then((res) => {
          if (res.length >= 5) {
            Db.read('recommendInstall', 'userName', user.attributes.email).then((result) => {
              this.recommendList.install = result === undefined ? [] : result;
            });
          }
        });
        Db.scan('operation', { email: user.attributes.email }, ['id']).then((res) => {
          if (res.length >= 10) {
            Db.read('recommendOperation', 'userName', user.attributes.email).then((result) => {
              this.recommendList.operation = result === undefined ? [] : result;
            });
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    routerFilterList(subject) {
      this.$store.commit('dbTable/setFilterList', this.cardDataList(subject));
      this.$store.commit('dbTable/setFilterSubject', this.$t(subject));
      this.$router.push({ name: 'filterList' });
    },
    cardHandler(productName) {
      this.$router.push({ name: 'cardDetail', params: { productName } });
    },
    cardDataList(subject) {
      if (!this.productList.length) return [];
      switch (subject) {
        case 'new&update':
          return this.newProductList;
        case 'recommend':
          return this.recommendProductList;
        case 'popular':
          return this.topProductList;
        case 'free':
          return this.productList.filter((item) => item.price === '0');
        case 'popular&free':
          return this.topProductList.filter((item) => item.price === '0');
        case 'popular&paid':
          return this.topProductList.filter((item) => item.price > 0);
        case 'new&free':
          return this.newProductList.filter((item) => item.price === '0');
        case 'new&paid':
          return this.newProductList.filter((item) => item.price > 0);
        default:
          return this.productList;
      }
    },
    setCarouselIndexHandler(index) {
      this.hasCarousel = true;
      this.carouselIndex = index;
    },
    carouselDetailHandler(index) {
      if (this.carouselList[index].classes === 'video') {
        this.hasVideo = true;
        this.videoUrl = `${this.carouselList[index].url.replace('watch?v=', 'embed/')}?rel=0&autoplay=1`;
      } else {
        window.location.href = this.carouselList[index].url;
      }
    },
    closeBulletin() {
      if (this.isNoShowNext) {
        const expiredDate = new Date().toLocaleDateString();
        console.log(expiredDate);
        window.localStorage.setItem('bulletinExpiredDate', expiredDate);
      }
      this.showBulletin = false;
    },
    loadLogo() {
      try {
        File.api('info.json').then((res) => {
          this.logoList = res.data;
        });
      } catch (err) {
        console.log(`Failed to load logo! ${err}`);
      }
    },
  },
};
</script>

<style>
@media (min-width: 480px) {
  .iframeSize {
    width: 426px;
    height: 240px;
  }
}
@media (min-width: 768px) {
  .iframeSize {
    width: 640px;
    height: 360px;
  }
}
@media (min-width: 992px) {
  .iframeSize {
    width: 854px;
    height: 480px;
  }
}
@media (min-width: 1200px) {
  .iframeSize {
    width: 1280px;
    height: 720px;
  }
}
.ql-editor img {
  max-width: 100%;
  width: 100%;
}
</style>
